let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9SSqq")).then(() => parcelRequire('iD2bB'));